import React from 'react';
import { Card } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import CalendarGraphic from 'components/InPersonTraining/shared/CalendarGraphic';
import AttendanceStatus from '../../shared/AttendanceStatus';
import SessionDetails from '../../shared/SessionDetails';

const EventsDashboardUpNextEvent = ({ nextAttendingEvent }) => {
  const { attendance, event, session, siblingSessions, urls } =
    nextAttendingEvent;
  const { rsvpType } = event;

  const isMultiSession = siblingSessions.length > 1;
  const eventRsvpType = !isMultiSession ? 'single_session' : rsvpType;
  const isSeries = eventRsvpType === 'all';
  const sortedSiblingSessions = siblingSessions.sort((a, b) =>
    moment(a.startTime).diff(moment(b.startTime)),
  );
  const maxAttendees = !isSeries
    ? session.maxAttendees
    : siblingSessions.find(siblingSession => siblingSession.maxAttendees)
        ?.maxAttendees;

  const eventStartTime = () => {
    if (!isMultiSession || rsvpType === 'single') {
      return session.startTime;
    }
    return sortedSiblingSessions[0].startTime;
  };

  const eventEndTime = () => {
    if (!isMultiSession || rsvpType === 'single') {
      return session.endTime;
    }
    return sortedSiblingSessions.at(-1).endTime;
  };

  const updatedSession = {
    ...session,
    endTime: eventEndTime(),
    maxAttendees,
    startTime: eventStartTime(),
  };

  return (
    <div>
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
          {t('in_person_training.events_dashboard.your_next_event')}
        </Text>
      </div>
      <Card
        cap="top"
        url={urls.register}
        className="EventsDashboardEvent EventsCardShadow MyTrainingEventsCard ff-ss mb-24 d-b"
      >
        <CalendarGraphic
          isLocalTime={false}
          sessionStartTime={session.startTime}
        />
        <Card.Content padding="medium">
          <div className="mb-8">
            <Text className="text-wrap" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
              {event.name}
            </Text>
          </div>
          <SessionDetails
            className="mb-8"
            eventId={event.id}
            rsvpType={rsvpType}
            session={updatedSession}
            sessionCount={isSeries && siblingSessions.length}
          />
          <AttendanceStatus status={attendance.status} />
        </Card.Content>
      </Card>
    </div>
  );
};

export default EventsDashboardUpNextEvent;
